import { Button } from "reactstrap";
import { GrView } from "react-icons/gr";
import { Navigate } from "react-router-dom";
import { UncontrolledTooltip } from "reactstrap";
import { FiEdit } from "react-icons/fi";
export const CompanyListColumns = (companyDetailsView: any, companyEditView: any, approveCompany: any) => [

  {
    name: "Organization Name",
    selector: (row: any) => row.organization.name,
    sortable: true,
  },
  {
    name: "Organization Name",
    selector: (row: any) => row.organization.name,
    sortable: true,
  },
  {
    name: "Plan Status",
    selector: (row: any) => row.organization.is_plan_active,
    cell: (row: any) => (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <span
          style={{
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            backgroundColor: row.organization.is_plan_active ? "green" : "red",
            boxShadow: `0 0 8px ${row.organization.is_plan_active ? "green" : "red"
              }`,
          }}
        />
        {row.organization.is_plan_active ? "Active" : "Inactive"}
      </div>
    ),
    sortable: true,
  },
  {
    name: "Approval Status",
    selector: (row: any) => row.admin_approved,
    sortable: true,
    cell: (row: any) => {
      let badgeClass = "";

      switch (row.admin_approved) {
        case "approved":
          badgeClass = "bg-success";
          break;
        case "rejected":
          badgeClass = "bg-danger";
          break;
        case "pending":
        default:
          badgeClass = "bg-warning text-dark";
          break;
      }

      return (
        <div>
          <span className={`badge ${badgeClass}`} style={{ padding: "0.4em 0.6em", fontSize: "0.85rem" }}>
            {row.admin_approved?.charAt(0).toUpperCase() + row.admin_approved?.slice(1)}
          </span>
        </div>
      );
    }
  },
  {
    name: "Plan Name",
    selector: (row: any) => row.plan.name,
    sortable: true,
    cell: (row: any) => (
      <span className="badge bg-primary">{row.plan.name}</span>
    ),
  },
  {
    name: "max users/ created users",
    selector: (row: any) => row.users_under_plan,
    sortable: true,
    cell: (row: any) => (
      <div>
        <span className="badge bg-primary">{row.users_under_plan}</span>
      </div>
    ),
  },
  {
    name: "Purchase Type",
    selector: (row: any) => row.is_online_purchase,
    sortable: true,
    cell: (row: any) => (
      <div className="d-flex align-items-center gap-2">
        <span
          className={`badge d-flex align-items-center gap-1 ${row.is_online_purchase
            ? "bg-success"
            : "bg-warning text-dark"}`}
          style={{ fontSize: "0.85rem", padding: "0.4em 0.6em" }}
        >
          <span>{row.is_online_purchase ? "🌐" : "🏪"}</span>
          <span>{row.is_online_purchase ? "Online" : "Offline"}</span>
        </span>

        {/* Show approve icon only for online users */}
        {row.is_online_purchase && row.admin_approved === "pending" && (
          <span
            title="Approve Purchase"
            onClick={() => approveCompany(row)}
            style={{
              cursor: "pointer",
              color: "#28a745",
              fontSize: "1.2rem"
            }}
          >
            🕒
          </span>
        )}
      </div>
    ),
  },
  {
    name: "Purchased date ",
    selector: (row: any) => row.purchase_date,
    sortable: true,
    cell: (row: any) => (
      <div>
        <span className=" badge bg-primary ">{row.purchase_date}</span>{" "}
      </div>
    ),
  },



  {
    name: "Expiry Date",
    selector: (row: any) => row.expiry_date,
    sortable: true,
    cell: (row: any) => (
      <div>
        <span className=" badge bg-secondary ">{row.expiry_date}</span>{" "}
      </div>
    ),
  },
  {
    name: "Actions",
    cell: (row: any) => {
      const viewId = `view-${row.id}`;
      const editId = `edit-${row.id}`;

      return (
        <div className="d-flex gap-3">
          {/* View Icon */}
          <span id={viewId} style={{ cursor: "pointer" }} onClick={() => companyDetailsView(row.organization.id)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              fill="currentColor"
              className="bi bi-eye-fill"
              viewBox="0 0 16 16"
            >
              <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
              <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
            </svg>
          </span>
          <UncontrolledTooltip target={viewId} placement="top">
            View
          </UncontrolledTooltip>

          {/* Edit Icon */}
          <span id={editId} style={{ cursor: "pointer" }} onClick={() => companyEditView(row.organization.id)}>
            <FiEdit size={18} color="#0d6efd" />
          </span>
          <UncontrolledTooltip target={editId} placement="top">
            Edit
          </UncontrolledTooltip>
        </div>
      );
    }
  }
  // {
  //     name: "Action",
  //     cell: (row: any) => (
  //         <Button color="danger" onClick={() => confirmDelete(row.id)}>Delete</Button>
  //     )

  // }
];
